import React, { useEffect, useState } from 'react';
import useRequest from '@/websdk/utils/request';
import specialValues from '@/constant/special_values';

export default (function (id, type, params) {
  const { data, isRequestSuccessed, exec } = useRequest({
    url: '',
    name: 'GET_CRAFT_PARAMS',
    method: 'GET',
  });

  const [newDatas, setNewDatas] = useState([]);

  useEffect(() => {
    if (id) {
      if (type === 'standardParams') {
        let url = `/api/produce-crafts/${id}/params/detail`;
        exec(url);
      } else {
        let url = `/api/devices/${id}/crafts/current-params`;
        if (params) {
          Object.keys(params).forEach((key, index) => {
            if (index === 0) {
              url += '?';
            } else {
              url += '&';
            }
            url += `${key}=${params[key]}`;
          });
        }

        exec(url);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (data && data.length !== 0) {
      let newDatas_ = [];
      data.forEach(cdata => {
        let newData_ = JSON.parse(JSON.stringify(cdata));
        newData_.img = (
          <img src={require('@/assets/images/process/' + newData_.icon_url)} alt={newData_.title} />
        );
        newData_.values = newData_.data.map(arr => {
          return arr.map(param => {
            if (param.value) {
              const value = param.value.toString().replace('.', '');
              if (specialValues.indexOf(value) !== -1) {
                param.value = '';
              }
            }
            return param.value;
          });
        });
        newDatas_.push(newData_);
      });
      setNewDatas(newDatas_);
    }
  }, [data, isRequestSuccessed]);
  if (params) {
    if (params.is_spotcheck === 1) {
      return [newDatas || [], isRequestSuccessed];
    } else {
      return newDatas;
    }
  } else {
    return newDatas;
  }
});
